import React, { useState, useEffect } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Card from 'react-bootstrap/Card';
import { ContentHeader } from '@components';
import * as AuthService from '../../services/auth';
import TablePin from './report/TablePin';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import useCopyToClipboard from './usehooks-ts';
import { DatePicker } from 'react-tempusdominus-bootstrap';
import ApvTemplate from './ApvTemplate';
import TableGroup from './report/TableGroup';
import TableRentalCar from './report/TableRentalCar';
import { logoutUser } from '@store/reducers/auth';
import { useDispatch } from 'react-redux';
import TableRole from './report/TableRole';
import TableCheckRegistration from './report/TableCheckRegistration';

export default function Cr() {
  const dispatch = useDispatch();
  const [key, setKey] = useState('pin');
  const [value, copy] = useCopyToClipboard();

  const [approveCarList, setApproveCarList] = useState<any[]>([]);

  useEffect(() => {
    downloadPinListWs();
    downloadRentalListWs();
    downloadCrWs();
    downloadNgvWs();
    downloadApproveCarWs();
  }, []);

  const downloadPinListWs = async () => {
    try {
      const pins = await AuthService.downloadPinlistWs();
      if (pins.error) throw 'timeout';
      setData(pins);
    } catch (error) {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const downloadRentalListWs = async () => {
    try {
      const cars = await AuthService.downloadCarslistWs();
      console.log(cars);
      if (cars.error) toast.error(cars.error);
      setCars(cars);
    } catch (error) { }
  };

  const downloadApproveCarWs = async () => {
    try {
      // เรียกใช้ฟังก์ชัน approveCar ที่อยู่ในไฟล์บริการส่งของเว็บ
      const result = await AuthService.approveCar();
      if (result.error) {
        toast.error(result.error);
        setApproveCarList([]);
      } else {
        setApproveCarList(result);
      }
    } catch (error) {
      setApproveCarList([]);
    }
  };

  const onAdd = async (car: any) => {
    try {
      const result = await AuthService.addRentalCar(car);
      if (result.length > 0) {
        toast.success('แก้ไขสำเร็จแล้ว');
      } else {
        toast.error('แก้ไขผิดพลาด');
      }
      setCars(result);
    } catch (error) { }
  };

  const onUpdate = async (car: any) => {
    try {
      console.log(car);
      const result = await AuthService.updateRentalCar(car);
      if (result.length > 0) {
        toast.success('แก้ไขสำเร็จแล้ว');
      } else {
        toast.error('แก้ไขผิดพลาด');
      }
      setCars(result);
    } catch (error) { }
  };

  const downloadNgvWs = async () => {
    try {
      const _ngv = await AuthService.uploadNgvWs({ ngv: 0 });
      if (_ngv.error) toast.error(_ngv.error);
      setNgv(_ngv.ngv);
    } catch (error) { }
  };
  const downloadCrWs = async () => {
    try {
      const show = await AuthService.downloadCrWs();
      if (show.error) toast.error(show.error);
      setShow(show.value);
    } catch (error) { }
  };
  const [show, setShow] = useState(false);
  const [state, setState] = useState({
    date: new Date(),
    staffid: ''
  });
  const [ngv, setNgv] = useState(0);
  const [data, setData] = useState<any[]>([]);
  const [cars, setCars] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const setPageHandle = (page: number) => {
    setPage(page);
  };

  const onNgvSubmit = async () => {
    try {
      if (ngv === 0) {
        toast.warning('กรุณากรอกราคา NGV');
      } else {
        const _ngv = await AuthService.uploadNgvWs({ ngv: ngv });
        if (_ngv.error) {
          console.log('error');
          toast.error(_ngv.error);
        } else {
          console.log('success');
          toast.success('ดำเนินการปรับราคา ngv แล้ว');
          setNgv(_ngv.ngv);
        }
      }
    } catch (error) { }
  };

  const onSubmit = async () => {
    try {
      if (state.staffid === '') {
        toast.warning('กรุณากรอกรหัสพนักงาน');
      } else {
        const pins = await AuthService.uploadPinWs(state);
        console.log(pins);
        if (pins.error) {
          console.log('error');
          toast.error(pins.error);
        } else {
          console.log('success');
          setData(pins);
          toast.success('ดำเนินการเพิ่มแล้ว');
          setState((prevState) => ({
            ...prevState,
            staffid: ''
          }));
        }
      }
    } catch (error) { }
  };

  return (
    <div>
      <ContentHeader title="Cockpit" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
              >
                <Tab eventKey="pin" title="ปลดล็อก">
                  <div className="col-12">
                    <Card className="card-primary">
                      <div className={show ? 'd-none' : 'overlay dark'}>
                        <span style={{ color: 'white', fontSize: 30 }}>
                          CR ONLY
                        </span>
                      </div>
                      <Card.Body>
                        <div className="row">
                          <DatePicker
                            date={state.date}
                            format="YYYY-MM-DD"
                            onChange={(e: any) => {
                              setState((prevState) => ({
                                ...prevState,
                                date: e.date
                              }));
                            }}
                          />
                          <Form.Group className="mb-3 col-md-2">
                            <Form.Control
                              type="number"
                              value={state.staffid}
                              placeholder="รหัสพนักงาน"
                              onChange={(e: any) => {
                                setState((prevState) => ({
                                  ...prevState,
                                  staffid: e.target.value
                                }));
                              }}
                            />
                          </Form.Group>
                          <Form.Group className="mb-3 col-md-2">
                            <Button onClick={onSubmit} variant={'success'}>
                              เพิ่ม
                            </Button>
                          </Form.Group>
                        </div>
                      </Card.Body>
                    </Card>
                    <Card className="card-primary">
                      <div className={show ? 'd-none' : 'overlay dark'}>
                        <span style={{ color: 'white', fontSize: 30 }}>
                          CR ONLY
                        </span>
                      </div>
                      <Card.Header>รายการรออนุมัติทั้งหมด</Card.Header>
                      <Card.Body>
                        <TablePin
                          onCopy={(value: string) => {
                            copy(value);
                            toast.success('คัดลอก pin แล้ว');
                          }}
                          items={data}
                          onPageChange={setPageHandle}
                          page={page}
                        />
                      </Card.Body>
                    </Card>
                  </div>
                </Tab>
                <Tab eventKey="role" title="กฎ">
                  <TableRole show={show}></TableRole>
                </Tab>
                <Tab eventKey="template" title="แม่แบบ">
                  <ApvTemplate></ApvTemplate>
                </Tab>
                <Tab eventKey="group" title="กลุ่ม">
                  <TableGroup show={show}></TableGroup>
                </Tab>
                <Tab eventKey="ngv" title="ปรับราคา NGV">
                  <div className="col-12">
                    <Card className="card-primary">
                      <div className={show ? 'd-none' : 'overlay dark'}>
                        <span style={{ color: 'white', fontSize: 30 }}>
                          CR ONLY
                        </span>
                      </div>
                      <Card.Body>
                        <div className="row">
                          <Form.Group className="mb-3 col-md-2">
                            <Form.Control
                              type="number"
                              value={ngv}
                              placeholder="ราคา NGV"
                              onChange={(e: any) => {
                                setNgv(Number(e.target.value));
                              }}
                            />
                          </Form.Group>
                          <Form.Group className="mb-3 col-md-2">
                            <Button onClick={onNgvSubmit} variant={'success'}>
                              ปรับปรุงราคา
                            </Button>
                          </Form.Group>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </Tab>
                <Tab eventKey="rental" title="รถยืม">
                  <TableRentalCar
                    onAdd={onAdd}
                    onUpdate={onUpdate}
                    show={show}
                    items={cars}
                  ></TableRentalCar>
                </Tab>
                {/* --- เมนูตรวจสอบการเพิ่มรถพนักงาน --- */}
                <Tab
                  eventKey="check-registration"
                  title={
                    approveCarList && approveCarList.length > 0 ? (
                      <>ตรวจสอบการลงทะเบียนรถ <span style={{ color: '#dc3545' }}>●</span></>
                    ) : (
                      "ตรวจสอบการลงทะเบียนรถ"
                    )
                  }
                >
                  <TableCheckRegistration
                    onRefresh={downloadApproveCarWs}
                    show={show}
                    items={approveCarList}
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
